import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-accent-50">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="text-xl font-heading font-semibold text-white cursor-pointer">
              永葆青春
            </Link>
            <p className="mt-3 text-sm text-accent-200 leading-relaxed max-w-xs">
              科学抗衰知识平台，汇集护肤养生、饮食运动、心理健康全方位抗衰老方案，助你由内而外绽放年轻光彩。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">知识分类</h4>
            <ul className="space-y-3">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-accent-200 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">更多分类</h4>
            <ul className="space-y-3">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-accent-200 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-accent-200 hover:text-white transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系方式</h4>
            <ul className="space-y-3 text-sm text-accent-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>contact@lztprh.cn</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5"></i>
                <span>400-888-6688</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>上海市静安区南京西路1688号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-accent-700/50 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-accent-300">
            &copy; {new Date().getFullYear()} 永葆青春 版权所有 | 科学抗衰，从今天开始
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-accent-300 hover:text-white transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-accent-300 hover:text-white transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-accent-300 hover:text-white transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-red-packet-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}